export default __webpack_public_path__ + "static/media/logoFams.cb4b1cab.svg";